import React from 'react';
import { connect } from 'react-redux';
import {
    BetaLocalizationTooltip,
    OptinLocalizationTooltip
} from './localization-link-tooltip';
import {
    selectShowLanguageSelectionTooltip,
    selectShowLanguageSelectionOptoutTooltip,
    dismissLanguageTooltip,
    dismissLanguageOptoutTooltip
} from 'tradera-state/language';
import { selectIsLoggedIn } from 'tradera-state/member';
import MediaQuery from 'react-responsive';

import { BREAKPOINTS, BREAKPOINT_SIZES } from 'tradera-utils/breakpoints';

export const MobileLocalizationTooltip = ({
    showTooltip,
    showOptoutTooltip,
    onCloseTooltip,
    onCloseOptoutToolTip,
    isLoggedIn
}) =>
    isLoggedIn ? (
        <MediaQuery maxWidth={BREAKPOINT_SIZES[BREAKPOINTS.MD].max}>
            <div className="position-relative">
                <div className="position-absolute mobile-tooltip">
                    <BetaLocalizationTooltip
                        show={showTooltip}
                        onClose={onCloseTooltip}
                    />
                    <OptinLocalizationTooltip
                        show={showOptoutTooltip}
                        onClose={onCloseOptoutToolTip}
                    />
                </div>
            </div>
        </MediaQuery>
    ) : null;

const mapStateToProps = state => ({
    showTooltip: selectShowLanguageSelectionTooltip(state),
    showOptoutTooltip: selectShowLanguageSelectionOptoutTooltip(state),
    isLoggedIn: selectIsLoggedIn(state)
});

const mapDispatchToProps = {
    onCloseTooltip: dismissLanguageTooltip,
    onCloseOptoutToolTip: dismissLanguageOptoutTooltip
};

export const ConnectedMobileLocalizationTooltip = connect(
    mapStateToProps,
    mapDispatchToProps
)(MobileLocalizationTooltip);
